import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';

// The device / asset register. staleTime 0 for the same reason as the SIM
// inventory — this screen exists to be edited, and a stale list is how two
// records end up disagreeing about who holds one laptop.
export function useDevices() {
  return useQuery({
    queryKey: ['devices'],
    queryFn: async () => {
      const { data } = await api.get('/api/devices');
      return data;
    },
    staleTime: 0,
    retry: false,
  });
}

function useDeviceMutation(mutationFn) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['devices'] });
    },
  });
}

export function useAddDevice() {
  return useDeviceMutation(async (device) => (await api.post('/api/devices', device)).data);
}

export function useUpdateDevice() {
  return useDeviceMutation(async ({ id, ...body }) => (await api.put(`/api/devices/${id}`, body)).data);
}

// Logistics collection queue — devices held by people currently being offboarded.
export function useDevicesToCollect() {
  return useQuery({
    queryKey: ['devicesToCollect'],
    queryFn: async () => {
      const { data } = await api.get('/api/devices/to-collect');
      return data;
    },
    staleTime: 0,
    retry: false,
  });
}

// Manual "sync now" — pull the estate from Atera + Wazuh.
export function useSyncDevices() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => (await api.post('/api/devices/sync')).data,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['devices'] });
      queryClient.invalidateQueries({ queryKey: ['devicesToCollect'] });
    },
  });
}

export function useCollectDevice() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id) => (await api.post(`/api/devices/${id}/collect`)).data,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['devicesToCollect'] });
      queryClient.invalidateQueries({ queryKey: ['devices'] });
    },
  });
}
